import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { JsonHalCollection } from "src/app/models/api/jsonhal.model";
import { InLineControlModel } from "src/app/models/api/inLineControl.model";
import { HttpService } from "../../http/http.service";
import { SortColumn } from "src/app/models/sortColumn.model";

@Injectable({
    providedIn: "root",
})
export class AiInLineControlHttpService {
    public readonly defaultPageSize: number = 50;
    private _httpService: HttpService;

    constructor(private _http: HttpClient) {
        this._httpService = new HttpService(this._http);
    }

    public startGetInLineControl(sortData?: SortColumn, pageSize = this.defaultPageSize): Observable<JsonHalCollection<InLineControlModel>> {
        const url = "detection/findings-ai-edge";
        const httpParams = this._createFindingsQueryParams(pageSize, sortData);
        return this._httpService.get<JsonHalCollection<InLineControlModel>>(url, undefined, httpParams, true);
    }

    private _createFindingsQueryParams(pageSize: number, sortData?: SortColumn, shouldLimitResultsAmount = true): HttpParams {
        let httpParams = new HttpParams();
        if (shouldLimitResultsAmount) {
            httpParams = httpParams.append("pageSize", pageSize);
        }

        if (sortData) {
            httpParams = this._appendFindingsSortQueryParams(httpParams, sortData);
        }
        return httpParams;
    }

    private _appendFindingsSortQueryParams(httpParams: HttpParams, sortData: SortColumn): HttpParams {
        const sortFieldString: string | undefined = sortData.column.sortKey;
        const ascOrDescString = sortData.isDesc ? "desc" : "asc";

        if (sortFieldString) {
            httpParams = httpParams.append("sortBy", `[${sortFieldString}(${ascOrDescString})]`);
        }
        return httpParams;
    }

    public getInLineControls(): Observable<InLineControlModel[]> {
        return this._http.get<InLineControlModel[]>("assets/mockData/inLineControlMockData.json");
    }

    public getInLineControlsByContinuationToken(continuationToken: string): Observable<JsonHalCollection<InLineControlModel>> {
        const url = "detection/in-line-controls-pages";
        const httpParams = new HttpParams().append("continuationToken", continuationToken);
        return this._httpService.get<JsonHalCollection<InLineControlModel>>(url, undefined, httpParams, true);
    }
}
